var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9.05826 3.86924C9.07901 3.57976 8.84976 3.3335 8.55954 3.3335H7.46291C7.1735 3.3335 6.94454 3.57845 6.96405 3.8672L7.30182 8.8672C7.31955 9.12966 7.53762 9.3335 7.80069 9.3335H8.20121C8.46348 9.3335 8.68118 9.13084 8.69993 8.86924L9.05826 3.86924ZM7.25923 13.1088C7.4785 13.2553 7.73628 13.3335 7.99999 13.3335C8.35361 13.3335 8.69275 13.193 8.9428 12.943C9.19285 12.6929 9.33332 12.3538 9.33332 12.0002C9.33332 11.7365 9.25513 11.4787 9.10862 11.2594C8.96211 11.0401 8.75387 10.8692 8.51023 10.7683C8.2666 10.6674 7.99851 10.641 7.73987 10.6924C7.48123 10.7439 7.24365 10.8709 7.05718 11.0574C6.87071 11.2438 6.74372 11.4814 6.69228 11.74C6.64083 11.9987 6.66723 12.2668 6.76815 12.5104C6.86907 12.754 7.03996 12.9623 7.25923 13.1088Z",
    fill: "#F23232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.dfcfd1defb4113db7c8dc5cf359a0e50.svg";
export { ForwardRef as ReactComponent };